import { createRoutine } from 'redux-saga-routines';

export const fetchCommunicationUsers = createRoutine(
  'FETCH_COMMUNICATION_USERS'
);
export const fetchCommunicationUserMappingValues = createRoutine(
  'FETCH_USER_MAPPING_VALUES'
);
export const createUserMappingValues = createRoutine(
  'CREATE_USER_MAPPING_VALUES'
);
